import { useEffect, useState } from "react";
import { Button, Checkbox, Col, Form, Modal, notification, Row } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-regular-svg-icons";

import { POST } from "../../../../providers/useAxiosQuery";
import FloatInput from "../../../../providers/FloatInput";
import FloatQuill from "../../../../providers/FloatQuill";
import validateRules from "../../../../providers/validateRules";
import FloatSelect from "../../../../providers/FloatSelect";
import FormListQuestionOptions from "./FormListQuestionOptions";
import notificationErrors from "../../../../providers/notificationErrors";

export default function ModalFormQuestion(props) {
	const {
		toggleModalQuestion,
		setToggleModalQuestion,
		form_question_category_id,
	} = props;

	const [form] = Form.useForm();

	const [hasOption, setHasOption] = useState(false);

	const { mutate: mutateForm, isLoading: isLoadingForm } = POST(
		"api/form_questions",
		"form_questions_list"
	);

	const onFinish = (values) => {
		let form_question_options = values.form_question_options
			? values.form_question_options.map((item) => ({
					...item,
					id: item.id ?? "",
					sub_options: item.sub_options
						? item.sub_options.map((item2) => ({
								...item2,
								id: item2.id ?? "",
						  }))
						: [],
			  }))
			: [];

		let data = {
			...values,
			id: toggleModalQuestion.data ? toggleModalQuestion.data.id : "",
			checkbox_with_input: values.checkbox_with_input === true ? "1" : "0",
			with_attachment: values.with_attachment === true ? "1" : "0",
			required: values.required === true ? "1" : "0",
			form_question_category_id,
			form_question_options,
		};

		mutateForm(data, {
			onSuccess: (res) => {
				if (res.success) {
					notification.success({
						message: "Question",
						description: res.message,
					});
					setToggleModalQuestion({
						open: false,
						data: null,
					});
					form.resetFields();
				} else {
					notification.error({
						message: "Question",
						description: res.message,
					});
				}
			},
			onError: (err) => {
				notificationErrors(err);
			},
		});
	};

	useEffect(() => {
		if (toggleModalQuestion.open) {
			if (toggleModalQuestion.data) {
				form.setFieldsValue({
					...toggleModalQuestion.data,
				});

				if (toggleModalQuestion.data.question_type) {
					let options = [
						"Text (Ranking)",
						"Radio (Button)",
						"Checkbox",
						"Select (Dropdown)",
					];

					if (options.includes(toggleModalQuestion.data.question_type)) {
						setHasOption(true);
					}
				}
			}
		}

		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [toggleModalQuestion]);

	return (
		<Modal
			wrapClassName="wrap-modal-question-form"
			closeIcon={<FontAwesomeIcon icon={faTimes} />}
			title="Question Form"
			open={toggleModalQuestion.open}
			footer={[
				<Button
					className="btn-main-primary outlined"
					size="large"
					key={1}
					onClick={() => {
						setToggleModalQuestion({
							open: false,
							data: null,
						});
						form.resetFields();
						setHasOption(false);
					}}
					disabled={isLoadingForm}
				>
					CANCEL
				</Button>,
				<Button
					className="btn-main-primary"
					type="primary"
					size="large"
					key={2}
					onClick={() => form.submit()}
					loading={isLoadingForm}
				>
					SUBMIT
				</Button>,
			]}
			onCancel={() => {
				setToggleModalQuestion({
					open: false,
					data: null,
				});
				form.resetFields();
				setHasOption(false);
			}}
			forceRender
		>
			<Form form={form} onFinish={onFinish}>
				<Row gutter={[10, 0]}>
					<Col xs={24} sm={24} md={24} lg={24} xl={24}>
						<Form.Item
							name="question"
							rules={[validateRules.required]}
							className="form-item-question"
						>
							<FloatQuill label="Question" placeholder="Question" required />
						</Form.Item>
					</Col>

					<Col xs={24} sm={24} md={12} lg={12} xl={12}>
						<Form.Item name="question_tips" className="form-item-question-tips">
							<FloatInput label="Question Tips" placeholder="Question Tips" />
						</Form.Item>
					</Col>
					<Col xs={24} sm={24} md={12} lg={12} xl={12}>
						<Form.Item name="option_label" className="form-item-option-label">
							<FloatInput label="Option Label" placeholder="Option Label" />
						</Form.Item>
					</Col>
					<Col xs={24} sm={24} md={24} lg={24} xl={24}>
						<Form.Item name="description" className="form-item-description">
							<FloatInput label="Description" placeholder="Description" />
						</Form.Item>
					</Col>

					<Col xs={24} sm={24} md={24} lg={24} xl={24}>
						<Row gutter={[10, 0]}>
							<Form.Item shouldUpdate noStyle>
								{() => {
									let question_type = form.getFieldValue("question_type");

									return (
										<>
											{question_type === "Checkbox" && (
												<Col xs={24} sm={12} md={6} lg={6} xl={6}>
													<Form.Item
														name="max_checkbox"
														className="form-item-max-checkbox"
														rules={[validateRules.required]}
													>
														<FloatInput
															label="Max Checkbox"
															placeholder="Max Checkbox"
															type="number"
															required
														/>
													</Form.Item>
												</Col>
											)}
											{question_type === "Text (Open Answer)" && (
												<Col xs={24} sm={12} md={6} lg={6} xl={6}>
													<Form.Item
														name="max_input_field"
														className="form-item-max-checkbox"
														rules={[validateRules.required]}
													>
														<FloatInput
															label="Max Input Field"
															placeholder="Max Input Field"
															type="number"
															required
														/>
													</Form.Item>
												</Col>
											)}
										</>
									);
								}}
							</Form.Item>

							<Col xs={24} sm={12} md={6} lg={6} xl={6}>
								<Form.Item
									name="with_attachment"
									valuePropName="checked"
									className="form-item-checkbox mb-0"
								>
									<Checkbox>With Attachment</Checkbox>
								</Form.Item>
							</Col>
							<Col xs={24} sm={12} md={6} lg={6} xl={6}>
								<Form.Item
									name="required"
									valuePropName="checked"
									className="form-item-checkbox mb-0"
								>
									<Checkbox>Required ?</Checkbox>
								</Form.Item>
							</Col>
						</Row>
					</Col>

					<Col xs={24} sm={24} md={24} lg={24} xl={24} className="pt-20">
						<Row gutter={[10, 0]}>
							<Col xs={24} sm={24} md={24} lg={24} xl={24}>
								<Row gutter={[10, 0]}>
									<Col xs={24} sm={24} md={12} lg={12} xl={12}>
										<Form.Item
											name="question_type"
											rules={[validateRules.required]}
										>
											<FloatSelect
												label="Question Type"
												placeholder="Question Type"
												required
												options={[
													{
														label: "Text (Input)",
														value: "Text (Input)",
													},
													{
														label: "Text (Open Answer)",
														value: "Text (Open Answer)",
													},
													{
														label: "Text (Ranking)",
														value: "Text (Ranking)",
													},
													{
														label: "Number (Input)",
														value: "Number (Input)",
													},
													{
														label: "Radio (Button)",
														value: "Radio (Button)",
													},
													{
														label: "Checkbox",
														value: "Checkbox",
													},
													{
														label: "Select (Dropdown)",
														value: "Select (Dropdown)",
													},
													{
														label: "Date (Datepicker)",
														value: "Date (Datepicker)",
													},
													{
														label: "Time (Timepicker)",
														value: "Time (Timepicker)",
													},
													{
														label: "Break / Note",
														value: "break",
													},
												]}
												onChange={(e) => {
													let options = [
														"Text (Ranking)",
														"Radio (Button)",
														"Checkbox",
														"Select (Dropdown)",
													];

													if (options.includes(e)) {
														setHasOption(true);
													} else {
														setHasOption(false);
													}
												}}
											/>
										</Form.Item>
									</Col>

									<Col
										xs={24}
										sm={24}
										md={24}
										lg={24}
										xl={24}
										style={{
											display: hasOption ? "block" : "none",
										}}
									>
										<Form.List name="form_question_options">
											{(
												fieldsOption,
												{ add: addOption, remove: removeOption }
											) => {
												return (
													<FormListQuestionOptions
														form={form}
														fieldsOption={fieldsOption}
														addOption={addOption}
														removeOption={removeOption}
													/>
												);
											}}
										</Form.List>
									</Col>
								</Row>
							</Col>
						</Row>
					</Col>
				</Row>
			</Form>
		</Modal>
	);
}
